import type { SVGProps } from 'react';
const DawnFlagLA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-LA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-LA_svg__a)">
      <path fill="#073A88" d="M0 11.733h22V4.267H0z" />
      <path fill="#E2273E" d="M0 4.267h22V0H0zM0 16h22v-4.267H0z" />
      <path
        fill="#fff"
        d="M11 10.667c1.446 0 2.619-1.194 2.619-2.667s-1.173-2.667-2.62-2.667C9.554 5.333 8.382 6.527 8.382 8S9.553 10.667 11 10.667"
      />
    </g>
  </svg>
);
export default DawnFlagLA;
